import { render, staticRenderFns } from "./applyHistory.vue?vue&type=template&id=244a8364&scoped=true&"
import script from "./applyHistory.vue?vue&type=script&lang=js&"
export * from "./applyHistory.vue?vue&type=script&lang=js&"
import style0 from "./applyHistory.vue?vue&type=style&index=0&id=244a8364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a8364",
  null
  
)

export default component.exports